// extracted by mini-css-extract-plugin
var _1 = "HomeHeader__button--XxZ2x";
var _2 = "HomeHeader__buttonPrimary--Fxq2l";
var _3 = "HomeHeader__buttonSecondary--fEuDY";
var _4 = "HomeHeader__buttons--cuTcd";
var _5 = "HomeHeader__container--ZS7Hg";
var _6 = "HomeHeader__content--MbQp6";
var _7 = "HomeHeader__section--n6vTG";
var _8 = "HomeHeader__shimmer--RA4We";
var _9 = "HomeHeader__skeletonAvatar--SHWET";
var _a = "HomeHeader__skeletonCard--si5Bd";
var _b = "HomeHeader__skeletonLine--zHSpY";
var _c = "HomeHeader__skeletonLineShort--M8vgq";
var _d = "HomeHeader__skeletonText--PogCa";
var _e = "HomeHeader__studentGrid--CamAS";
var _f = "HomeHeader__textBlue--i2sR3";
export { _1 as "button", _2 as "buttonPrimary", _3 as "buttonSecondary", _4 as "buttons", _5 as "container", _6 as "content", _7 as "section", _8 as "shimmer", _9 as "skeletonAvatar", _a as "skeletonCard", _b as "skeletonLine", _c as "skeletonLineShort", _d as "skeletonText", _e as "studentGrid", _f as "textBlue" }
